// ./src/components/features/Policies/policyVariables.ts
//
// The merge variables offered in the policy editors' "Insert variable" menu.
// Sourced from the central content-template registry so every surface (waivers,
// website content, emails, …) stays consistent — extend it in
// `@/utils/contentTemplate/variables`, not here. Inserted as literal `{{key}}`
// tokens; substituted at preview/print time (missing → a width-aware blank, and
// signature/initials → an image when the guest has one).

import { variableMenuItems, variableToken, VariableMenuEntry } from "@/utils/contentTemplate";

export type PolicyVariable = VariableMenuEntry;

// Grouped merge variables (event / venue / guest / …) for the editors' menu.
export const POLICY_VARIABLES: PolicyVariable[] = variableMenuItems();

export { variableToken };
